import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LandingState } from 'src/app/store/landing/landing.state';
import {
	IFeatureCareers,
	INewestListings
} from 'src/app/store/landing/landing-interface';
import { LandingActions } from 'src/app/store/landing/landing.actions';
import { AppCommon } from 'src/app/shared/app.common';
import { ApplicationsState } from 'src/app/store/applications/applications.state';
import { IApplications } from 'src/app/store/applications/applications.interface';
import { MsalLoginService } from 'src/app/services/msal.service';
import { JobListActions } from 'src/app/store/job-list/job-list.actions';
import { IpDetectorState } from 'src/app/store/ip-detector/ip-detector.state';
import { filter, finalize, take } from 'rxjs/operators';
import * as _ from 'underscore';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { GlobalHelperService } from 'src/app/services/global-helper.service';
import { SITE_DATA } from 'src/app/productization/default.constant';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { RouterLink } from '@angular/router';
import { NgTemplateOutlet, NgClass } from '@angular/common';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzButtonModule } from 'ng-zorro-antd/button';

@Component({
    selector: 'app-job-listing',
    templateUrl: './job-listing.component.html',
    styleUrls: ['./job-listing.component.scss'],
    imports: [NzTabsModule, NzGridModule, RouterLink, NgTemplateOutlet, NzTooltipModule, NgClass, NzSpaceModule, NzButtonModule]
})
export class JobListingComponent implements OnInit {
	private readonly store = inject(Store);
	private readonly destroyRef = inject(DestroyRef);
	private readonly ngxLoader = inject(NgxUiLoaderService);
	private readonly globalHelper = inject(GlobalHelperService);
	private readonly msalLoginService = inject(MsalLoginService);
	private readonly getIpAddress = this.store.select(IpDetectorState.getIp);
	private readonly jobLandingResult = this.store.select(LandingState.getLandingData);
	private readonly applicationsResult = this.store.select(ApplicationsState.getApplications);
	public feautureCareers: IFeatureCareers[] = [];
	public newestListings: INewestListings[] = [];
	public applications: IApplications[];
	private readonly siteData = SITE_DATA;
	ngOnInit(): void {
		this.jobLandingResult?.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
			this.feautureCareers = data.featureCareers;
			this.newestListings = data.newestListings;
		});

		this.applicationsResult?.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
			this.applications = data.applications;
		});

		this.getIpAddress
			.pipe(
				filter((e: any) => !_.isEmpty(e)),
				take(1),
				finalize(() => {
					this.ngxLoader.stop();
				})
			)
			.subscribe({
				next: (e: any) => {
					this.store.dispatch(
						new LandingActions.GetHotJobList({
							value:
								this.siteData.defaultCountry === 'none'
									? e?.country_name
									: this.siteData.defaultCountry
						})
					);
				}
			});
	}

	public getIconCategory(category: string) {
		return AppCommon.getIconCategory(category);
	}

	public getCardAge(date: Date) {
		return AppCommon.getAge(date);
	}

	public applyJr(jrId: number, e: Event) {
		e.stopPropagation();
		e.preventDefault();
		this.store.dispatch(new JobListActions.GetJobRequestById(jrId));
		setTimeout(() => {
			this.msalLoginService.globalJobRequestApply(jrId);
		}, 500);
	}

	public checkAppliedJr(jrId: number): boolean {
		let result = false;
		this.applications.forEach((application) => {
			if (application.jobRequestId === jrId) {
				result = true;
			}
		});
		return result;
	}

	public addSpaces(text: any) {
		return text.replace(/,/g, ', ');
	}

	public changeLocationStr(text: any): string {
		return this.globalHelper.cleanLocationText(text);
	}
}
